module.exports = __webpack_public_path__ + "img/4.3e1f6c85.jpeg";